import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FeatureComponent } from 'src/app/shared/components/feature/feature.component';
import { IntroContainerComponent } from 'src/app/shared/components/intro-container/intro-container.component';
import { SectionSubstitleComponent } from 'src/app/shared/components/section-subtitle/section-subtitle.component';
import { SectionComponent } from 'src/app/shared/components/section/section.component';
import { SubsectionComponent } from 'src/app/shared/components/subsection/subsection.component';

@Component({
  selector: 'app-craft-calculator-intro',
  imports: [IntroContainerComponent, SectionComponent, SubsectionComponent, FeatureComponent, SectionSubstitleComponent, RouterLink],
  templateUrl: './craft-calculator-intro.component.html',
  styleUrl: './craft-calculator-intro.component.scss',
})
export class CraftCalculatorIntroComponent {}
